﻿// <auto-generated/>
// this class has been generated with PowerShell
// see ./solution/Sbb.Meetings.Core/pre-build.ps1
/* eslint-disable */

import { TranslationLabels } from "./TranslationLabels";
export const frenchLabels: TranslationLabels = {
  Actions: "Actions",
  Actions_Add: "Ajouter",
  Actions_Add_Board: "Ajouter",
  Actions_AddBoard: "Créer",
  Actions_AddMeeting: "Ajouter",
  Actions_AddMeeting_Submitting: "Création de la séance …",
  Actions_Back: "Retour à",
  Actions_Browse: "Parcourir …",
  Actions_Cancel: "Annuler",
  Actions_Close: "Fermer",
  Actions_Close_AriaLabel: "Fermer",
  Actions_Copy_AgendaItem: "Copier",
  Actions_Delete: "Supprimer",
  Actions_Delete_AgendaItem: "Supprimer",
  Actions_Delete_AgendaItem_Confirm: "Veux-tu vraiment supprimer le point ?",
  Actions_Delete_AgendaItem_Pending: "Le point de l'ordre est en train d'être supprimé …",
  Actions_Delete_Document: "Supprimer document",
  Actions_Delete_Document_Confirm: "Veux-tu vraiment supprimer ce document ?",
  Actions_Delete_Document_Pending: "Le document est en train d'être supprimée…",
  Actions_Delete_Meeting: "Supprimer",
  Actions_Delete_Meeting_Confirm: "Veux-tu vraiment supprimer la séance avec tous les points, participants et points en suspens?",
  Actions_Delete_Meeting_Pending: "La séance avec tous les points, tous les participants et tous les points en suspens sera supprimée …",
  Actions_Delete_Participant: "Supprimer",
  Actions_Delete_Participant_Confirm: "Veux-tu vraiment supprimer ce participant ?",
  Actions_Delete_Participant_Pending: "Le participant est en train d'être supprimé…",
  Actions_Delete_Task_Confirm: "Veux-tu vraiment supprimer cette tâche ?",
  Actions_Delete_Task_Pending: "La tâche est en train d'être supprimée…",
  Actions_Delete_Task_Title: "Supprimer tâche",
  Actions_DocumentsGrid_Tooltip: "Actions de synchronisation",
  Actions_Download: "Télécharger",
  Actions_Edit: "Modifier",
  Actions_Edit_AgendaItem: "Editer le point",
  Actions_Edit_Meeting: "Modifier séance",
  Actions_Edit_Participant: "Modifier participants",
  Actions_Edit_Task: "Modifier tâche",
  Actions_EditSettings: "Modifier paramètres",
  Actions_GoToBoard: "Ouvrir les configurations de l'organe",
  Actions_GoToMeetings: "Ouvrir les séances de l'organe",
  Actions_Help: "Aide",
  Actions_HideChildren: "Masquer les subordonnés",
  Actions_HideDiff: "Masquer les différences",
  Actions_Indent_AgendaItem: "Augmenter l'indentation",
  Actions_Move_AgendaItem: "Déplacer",
  Actions_No: "Non",
  Actions_None: "Aucune",
  Actions_OneDriveMeetingFolder: "Ouvrir le dossier de la réunion sur OneDrive (disponible uniquement une fois la synchronisation terminée).",
  Actions_OneDriveSync: "Sychroniser",
  Actions_OneDriveSync_Delete: "Supprimer",
  Actions_OneDriveSync_Failure: "La synchronisation avec OneDrive n'a pas pu être effectuée, essaie à nouveau s'il te plaît.",
  Actions_OneDriveSync_Success: "La synchronisation avec OneDrive a été effectuée avec succès.",
  Actions_OneDriveSyncFolder: "Ouvrir le dossier",
  Actions_Open: "Ouvrir",
  Actions_OpenPhonebook: "Ouvrir l'annuaire téléphonique",
  Actions_OpenUserProfile: "Ouvrir le profil utilisateur",
  Actions_Outdent_AgendaItem: "Reduire l'indentation",
  Actions_Overwrite: "Écraser",
  Actions_Participant_Edit: "Modifier participant",
  Actions_Refresh: "Actualiser",
  Actions_Reset: "Réinitialiser",
  Actions_Retry: "Réessayer",
  Actions_Save: "Sauvegarder",
  Actions_SendTo_AgendaItem: "Envoyer à",
  Actions_ShowChildren: "Afficher les subordonnés",
  Actions_ShowDiff: "Afficher les différences",
  Actions_Submit: "Sauvegarder",
  Actions_Synchronize: "Synchroniser",
  Actions_ToggleDetails: "Afficher/masquer les détails",
  Actions_View: "Détails",
  Actions_View_AgendaItems: "Ouvrir les points",
  Actions_View_Documents: "Afficher documents",
  Actions_View_History: "Historique des versions",
  Actions_View_Meeting: "Ouvrir la séance",
  Actions_View_OneDriveSync: "Afficher synchronisation OneDrive",
  Actions_View_Participants: "Ouvrir le participant",
  Actions_View_Tasks: "Ouvrir les tâches",
  Actions_Yes: "Oui",
  AddAgendaItemPosition: "Insérer à",
  AddAgendaItemPosition_AfterSelected: "Après le sélectionné",
  AddAgendaItemPosition_ContextHelp: "Choisir l’endroit où le nouveau point de l’ordre du jour doit être inséré. «À la fin» est affiché à la fin de la réunion. «Après le sélectionné» le place directement après le point de l’ordre du jour actuellement choisi. Si aucun point de l’ordre du jour n’est sélectionné, il est également ajouté à la fin.",
  AddAgendaItemPosition_Last: "À la fin",
  AddBoard_Label: "Ajouter organe",
  AddBoardPanel_Header: "Ajouter organe",
  Added: "Ajouté",
  AddGroupMember: "Ajouter membre",
  AddMeeting_Description: "Veuillez définir ici le titre de la séance (les détails peuvent être adaptés par la suite). Veuillez utiliser le format suivant: YYYY-MM-TT_abréviation de la séance d'organe (Example: 2019-08-12_KL-Séance)",
  AddMeeting_Title: "Ajouter une séance",
  AddParticipant_Description: "Toutes les personnes autorisées de l'organe peuvent être ajoutées comme participants aux séances.",
  AddParticipant_NoDataTemplate: "Participant non trouvé. Des participants supplémentaires peuvent être ajoutés dans les paramètres d'organe.",
  AddParticipant_Placeholder: "Ajouter un participant …",
  AddParticipant_Title: "Ajouter participants",
  AddUser: "Ajouter",
  AddUser_Label: "Ajouter utilisateur*",
  Admin: "Admin",
  AdminBoardsFilter_Placeholder: "Recherche des organes …",
  AdminUsersFilter_Placeholder: "Recherche des utilisateurs …",
  AgendaItem: "Point de l'ordre",
  AgendaItem_Add_Submitting: "Création de point …",
  AgendaItem_AdditionalInfo_Description: "-",
  AgendaItem_AdditionalInfo_Title: "Texte supplémentaire",
  AgendaItem_Confidential_Active_Tooltip: "Ce point est strictement confidentiel. Les documents de travail seront gérés à l'exterieur de la gestion de la séance et le protocole (strictement confidentiel) sera distribué de manière séparée.",
  AgendaItem_Confidential_Description: "Veuillez indiquer ici si le point est strictement confidentiel. La soumission des documents correspondants doit avoir lieu par e-mail et le protocole doit se faire avec un protocole strictement confidentiel séparé.",
  AgendaItem_Confidential_Inactive_Tooltip: "Le point est strictement confidentiel.",
  AgendaItem_Confidential_Title: "Strictement confidentiel",
  AgendaItem_Confidential_Tooltip: "Strictement confidentiel",
  AgendaItem_Decision_Description: "Veuillez indiquer la description de la décision (transfer du modèle).",
  AgendaItem_Decision_Title: "Décision",
  AgendaItem_Department_Description: "Veuillez indiquer ici l'abréviation de l'unité responsable du point. En principe, toujours -1 à -2 niveaux hiérarchiques. Par exemple, \"F\", \"K-UE\", \"G\".",
  AgendaItem_Department_Title: "Unité responsable (Abréviation)",
  AgendaItem_Department_Tooltip: "Unité responsable",
  AgendaItem_DocumentStatus_Description: "Affiche le nombre de documents associés au point",
  AgendaItem_DocumentStatus_Title: "Documents de travail",
  AgendaItem_DocumentStatus_Tooltip: "Documents",
  AgendaItem_Duration_Description: "Veuillez indiquer ici la durée du point en minutes. Indiquez toujours le minimum comme convenu ou comme absolument nécessaire.",
  AgendaItem_Duration_Title: "Durée [min.]",
  AgendaItem_Duration_Tooltip: "Temps nécessaire",
  AgendaItem_EdecideType_Description: "Le type de modèle eDecide est utilisé pour créer une activité eDecide. La valeur par défaut est vide. Seuls les ordres du jour contenant un type de modèle != vide seront transmis à eDecide.",
  AgendaItem_EdecideType_Title: "Type de modèle eDecide",
  AgendaItem_EdecideType_Tooltip: "Type de sujet eDecide",
  AgendaItem_Edit: "Modifier",
  AgendaItem_EndTime_Description: "Ce champ est calculé sur la base de l'heure de départ de la séance et de la durée totale de tous ces points.",
  AgendaItem_EndTime_Title: "Heure de fin",
  AgendaItem_FinalBoard_Description: "Veuillez indiquer dans ce champ le organe final (abréviation) avec le type de modèle (BV, IV, autres). Exemple: KL-BV, VR-IV, atelier BPL.",
  AgendaItem_FinalBoard_Title: "Organe final / type de modèle",
  AgendaItem_FinalBoard_Tooltip: "Organe final / type de modèle",
  AgendaItem_FinalBoardDate_Title: "Organe final date",
  AgendaItem_Guests_Description: "Veuillez saisir ici les invités du point. Vous pouvez saisir plusieurs valeurs en les séparant avec un point-virgule <code>;</code> où en ajoutant une nouvelle ligne.",
  AgendaItem_Guests_Title: "Invités",
  AgendaItem_HeadingNumber_Description: "-",
  AgendaItem_HeadingNumber_Title: "No.",
  AgendaItem_Level_Description: "Champ interne, ne sera pas affiché",
  AgendaItem_Level_Title: "Retrait",
  AgendaItem_Locked_Active_Tooltip: "Ce point de l'ordre du jour est bloqué pour les membres.",
  AgendaItem_Locked_Description: "Veuillez bloquer ici le point de l'ordre du jour si personne, à part les propriétaires de l'organe, ne doit plus rien adapter.",
  AgendaItem_Locked_Inactive_Tooltip: "Le point de l'ordre du jour est ouvert aux membres pour traitement.",
  AgendaItem_Locked_Title: "Bloqué",
  AgendaItem_Locked_Tooltip: "Bloqué pour modification par les membres",
  AgendaItem_Meeting_ContextHelp_Title: "Séance",
  AgendaItem_NavBar_AddAgendaItem: "Ajouter",
  AgendaItem_NavBar_MeetingIsTemplate: "La séance est une séance standard (aka modèle) et est bloquée pour la modification par les membres.",
  AgendaItem_NavBar_MeetingLocked: "La séance est bloquée pour la modification par les membres.",
  AgendaItem_NavBar_SubmittedAgendaItems: "Points soumis",
  AgendaItem_NavBar_ToggleNav: "Visualiser/Cacher la navigation",
  AgendaItem_NavBar_ToggleView: "Séléctionner la vue",
  AgendaItem_NavBar_View: "Vue",
  AgendaItem_New_Placeholder: "Nouveau point …",
  AgendaItem_Note_Description: "Saisissez ici les informations supplémentaires pour le point.",
  AgendaItem_Note_Title: "Remarques",
  AgendaItem_Perusal_Description: "Veuillez indiquer ici la description de la décision pour la consultation (transférer du modèle).",
  AgendaItem_Perusal_Title: "Consultation",
  AgendaItem_Position_Description: "Champ interne, ne sera pas affiché",
  AgendaItem_Position_Title: "Position",
  AgendaItem_ProtocolEntry_Description: "Texte de la demande du modèle word, avec lequel les unités peuvent soumettre leurs points dans les séances. Ev. = Décision. La saisie est effectuée par les unités",
  AgendaItem_ProtocolEntry_Title: "Point du protocole",
  AgendaItem_ProtocolEntryDraft_Description: "Point de protocole qui ne sera pas affiché sur l'iPad.",
  AgendaItem_ProtocolEntryDraft_Title: "Point du protocole (conception)",
  AgendaItem_Sortable: "-",
  AgendaItem_Sortable_Tooltip: "Les points peuvent être triés par glisser-déposer.",
  AgendaItem_Speakers_Title: "Invités (Protocole)",
  AgendaItem_StandardVersion_Title: "Version standard",
  AgendaItem_StartTime: "-",
  AgendaItem_StartTime_Title: "Heure de début",
  AgendaItem_StartTime_Tooltip: "Début",
  AgendaItem_Status: "Etat",
  AgendaItem_Status_Description: "Status du point. Informativ.",
  AgendaItem_Status_Title: "Statut",
  AgendaItem_Title_Description: "Champ interne - Crée sur la base du champ Description et raccourcis à 255 caractères au maximum",
  AgendaItem_Title_Title: "Titre",
  AgendaItem_Type_Description: "Saisissez le type.",
  AgendaItem_Type_Title: "Type",
  AgendaItems: "Points",
  AgendaItems_Description: "Contient les ordres du jour d'organe",
  AgendaItems_Loading: "Charger les points …",
  AgendaItems_Loading_EditForm: "Chargement du formulaire des points …",
  AgendaItems_Title: "Points",
  AgendaItemsDetail_Empty: "S'il te plaît sélectionne un point",
  AgendaItemsList_Empty: "Aucun point n'a été saisi",
  AgendaItemStatus_Approved: "Approuvé",
  AgendaItemStatus_Archived: "Archivé",
  AgendaItemStatus_Default: "En cours",
  AgendaItemStatus_Deleted: "Supprimé",
  AgendaItemStatus_Finalized: "Terminé",
  AgendaItemStatus_Itemized: "A l'ordre du jour",
  AgendaItemStatus_Published: "Publié",
  AgendaItemStatus_Unknown: "Inconnu",
  AgendaItemType_Break: "Pause",
  AgendaItemType_Category: "Categorie",
  AgendaItemType_Decision: "BV",
  AgendaItemType_Decision_eDecide: "BV - eDecide",
  AgendaItemType_Decision_Tooltip: "Dossier pour décision",
  AgendaItemType_Discussion: "Discussion",
  AgendaItemType_Empty: "Vide",
  AgendaItemType_Information: "IV",
  AgendaItemType_Information_eDecide: "IV - eDecide",
  AgendaItemType_Information_Tooltip: "Dossier pour information",
  AgendaItemType_NoDataTemplate: "Pas trouvé le type",
  AgendaItemType_Other: "Autres",
  AgendaItemType_Placeholder: "Sélectionne le type …",
  All: "Tous",
  ApplicationName: "SiVe",
  AuditLog: "Journal d'audit",
  AuditLog_Action: "Action",
  AuditLog_Add: "Ajouté",
  AuditLog_After: "Après",
  AuditLog_Before: "Avant",
  AuditLog_Changes: "Modifications",
  AuditLog_Created: "Date",
  AuditLog_CreatedBy: "Utilisateur",
  AuditLog_Date: "A la date",
  AuditLog_Diff: "Différences",
  AuditLog_Id: "Id",
  AuditLog_Properties: "Champs",
  AuditLog_Property: "Champ",
  AuditLog_Remove: "Supprimé",
  AuditLog_State: "Action",
  AuditLog_Update: "Modifié",
  AuditLog_User: "par",
  AuditLogs: "Journaux d'audit",
  Auth_Loading: "Chargement de l'application …",
  Auth_LoginFailed: "La vérification a échoué.",
  Auth_Redirecting: "Chargement de vérification …",
  Auth_TryAgain: "Essaie à nouveau.",
  Back: "Retour à",
  BackHome: "Retour à la page d'accueil",
  BaseData: "Données de base",
  BlobDocument: "Document",
  Board: "Organe",
  Board_ArchivedDate: "Date d'archivage",
  Board_BoardUniqueId: "Id de l'organe eDecide",
  Board_BoardUniqueId_Help: "L'identifiant de l'organe eDecide est utilisé pour envoyer les exécutions du l'organe actuel vers eDecide. Cet ID peut être copié dans l'écran Gérer le l'organe d'eDecide. La fonction Envoyer à n'est active que si un ID a été saisi ici.",
  Board_BusinessOwner: "Personne responsable",
  Board_BusinessOwner_Help: "La personne qui assume la responsabilité technique de cet organe l'a initialement constituée ou l'a reprise d'un précédent responsable.",
  Board_ClearCache: "Vider le cache de l'organe",
  Board_DefaultDuration: "Durée standard",
  Board_DefaultDuration_Help: "La durée par défaut est ajoutée à l'heure de début de chaque nouvelle séance créée et donne l'heure de fin prévue.",
  Board_DefaultLocation: "Lieu/salle de séance",
  Board_DefaultLocation_Help: "Ce texte sera inscrit comme lieu/salle de séance à chaque nouvelle séance créée.",
  Board_DefaultRemarks: "Remarques",
  Board_DefaultRemarks_Help: "Ce texte est inscrit en tant que remarque à chaque nouvelle séance créée.",
  Board_DefaultTime: "Heure de début hh:mm",
  Board_DefaultTime_Help: "L'heure est utilisée comme heure de début proposée pour chaque nouvelle séance créée.",
  Board_Description: "Description",
  Board_Description_Help: "-",
  Board_DownloadConfig: "Télécharger la configuration",
  Board_DownloadConfig_Tooltip: "Télécharge la liste de configuration sous forme de fichier zip",
  Board_DownloadUsers: "Télécharger la liste d'utilisateurs",
  Board_DownloadUsers_Tooltip: "Télécharger la liste des utilisateurs sous forme de fichier CSV",
  Board_EdecideId: "Id de l'organe eDecide",
  Board_EdecideId_Help: "L'identifiant de l'organe eDecide est utilisé pour envoyer les exécutions de l'organe actuel vers eDecide. Cet ID peut être copié dans l'écran Gérer de l'organe dans eDecide. La fonction Envoyer à n'est active que si un ID a été saisi ici.",
  Board_Id: "Id",
  Board_Id_Help: "Clé de la base de données de l'organe",
  Board_LongName: "Nom longue",
  Board_LongName_Help: "Le nom longue est utilisé dans les modèles de documents et dans l'interface utilisateur de la gestion des séances. Les valeurs habituelles sont le nom complet de l'organe, comme Conseil d'administration ou Direction du groupe.",
  Board_Name: "Nom interne",
  Board_Name_Help: "Le nom interne est utilisé comme nom unique de l’organe dans la barre d’adresse du navigateur (URL). Lorsqu’un nom interne est modifié, les anciens noms internes restent affectés à l’organe et sont conservés dans le système.",
  Board_NameHistories_Title: "Noms précédents",
  Board_OrganisationUnit: "Unité organisationnelle",
  Board_OrganisationUnit_Help: "L'unité organisationnelle chargée de la gestion technique de cet organe correspond généralement à la personne responsable.",
  Board_Settings: "Paramètres de l'organe",
  Board_ShortName: "Nom abrégé",
  Board_ShortName_Help: "Le nom abrégé de l'organe est utilisé dans les modèles de documents et dans l'interface utilisateur de la gestion des séances. Les valeurs habituelles sont une abréviation de l'organe comme VR (conseil d'administration), KL (direction du groupe)",
  Board_SignatureFirstName: "Prénom de la signature",
  Board_SignatureFirstName_Help: "Le prénom de la signature peut être inséré lors de la génération des e-mails, des protocoles et des invitations.",
  Board_SignatureLastName: "Nom de famille de la signature",
  Board_SignatureLastName_Help: "Le nom de famille de la signature peut être inséré lors de la génération des e-mails, des protocoles et des invitations.",
  Board_Status: "Statut",
  Board_Status_Help: "Le statut de l'organe reflète son cycle de vie dans SiVe. Les organes supprimés n'apparaissent plus dans le tableau de bord.",
  Board_Update_Error: "L'organe n'a pas pu être enregistré: {0}",
  Board_Update_Success: "Le organe a été enregistré",
  BoardMemberships: "Droits d'accès",
  BoardPicker_Placeholder: "Organes saisir un terme de recherche …",
  Boards: "Organes",
  BoardSettings: "Paramètres de l'organe",
  BoardSettings_MeetingDefaults: "Valeurs par défaut pour les séances",
  BoardSettings_StandardMeetingOldOnly: "Les paramètres suivants ne sont utilisés qu’en cas d’application de la séance standard  «{0}».",
  BoardStatus_Active: "Actif",
  BoardStatus_Archived: "Archivé",
  BoardStatus_Deleted: "Supprimé",
  BoardStatus_Draft: "Brouillon",
  BoardStatus_Unknown: "Inconnu",
  BoardTemplate_Delete_Error: "Impossible de supprimer le modèle : {0}",
  BoardTemplate_Delete_Success: "Le modèle a été supprimé",
  BoardTemplate_Upload_Error: "Le modèle n'a pas pu être téléchargé : {0}",
  BoardTemplate_Upload_Success: "Le modèle a été téléchargé avec succès",
  BoardTemplate_UploadTitle: "Télécharger le modèle",
  BoardTemplates_Description: "Ces modèles ont été adaptés pour l'organe actuel. Contacte egpl@sbb.ch si tu as besoin d'aide pour la configuration.",
  BoardTemplates_Title: "Modèles d'organes",
  BoardUnique: "ID unique",
  BusinessOwner: "Propriétaire professionnel",
  ButtonHelp: "Aide",
  By: "par",
  ClaimIssuer: "Émetteur de la demande",
  Claims: "Demandes de l'utilisateur",
  ClaimType: "Type de demande",
  Confirm_Accept: "OUI",
  Confirm_Cancel: "Annuler",
  Confirm_Content: "Des modifications non enregistrées ont été détectées. Veux-tu vraiment annuler ?",
  Confirm_Discard: "Rejeter les modifications",
  Confirm_Title: "Modifications non enregistrées",
  ContextHelp: "Aide",
  ContextHelp_Fallback_Content: "Aucune aide contextuelle n'a été saisie pour le thème {0}.",
  ContextHelp_Fallback_Title: "Aide",
  ContextHelp_TemplateId_Description: "Les attributs de la séance standard sélectionnée (séance, ordre du jour, participants) sont repris lors de la création de la nouvelle séance. Si tu choisis vide, seule la séance sera créée, ainsi l'ordre du jour et les participants pourront être appliqués plus tard.",
  ContextHelp_TemplateId_Title: "Choisir la séance standard",
  CopyToClipboard: "Copier dans le presse-papier",
  CopyToClipboard_Idle: "Copier dans le presse-papiers…",
  CopyToClipboard_Success: "Copié !",
  Created: "Créé",
  Dashboard_Button_OwnerExport: "Télécharger la liste non-filtrée",
  Dashboard_Button_UserExport: "Télécharger la liste filtrée",
  Dashboard_EmptyTable: "Aucune séance correspondant à tes critères n'a été trouvée.",
  Dashboard_Filter_Tasks: "Seulement mes tâches",
  Dashboard_Grid_Header_EndDate: "Date de soumission des documents préliminaires",
  Dashboard_Grid_Header_Meeting: "Séance",
  Dashboard_Grid_Header_StartDate: "Date de départ",
  Dashboard_Loading: "Chargement des séances …",
  Dashboard_Meeting_PlannedEndTime: "Heure de fin planifiée",
  Dashboard_Meeting_ProjectedEndTime: "Heure de fin effective",
  Dashboard_Meeting_Tooltip: "Nombre de séances à partir de la date sélectionnée",
  Dashboard_Navbar_DetailedDashboard: "Ouvrir le dashboard détaillé",
  Dashboard_Navbar_Edecide: "Ouvrir eDecide",
  Dashboard_Toggle_MyCommittees: "Mes organes",
  Dashboard_Toggle_Tasks: "Afficher les tâches",
  Date_Unknown: "Inconnu",
  DateFilterBar_Dashboard_Description: "Les séances planifiées de tous les organes seront affichées sur le tableau de board. Avec le filtre de dates ont peux modifier la période d'affichage (La configuration de base est la date actuelle -14 jours). Tous les organes et les séances affichés peuvent être ouverts au moyen d'un clic.",
  DateFilterBar_Dashboard_Title: "Filtre de dates",
  DateFilterBar_Meetings_Description: "Avec le filtre de dates ont peux modifier la période d'affichage (La configuration de base est la date actuelle -14 jours)",
  DateFilterBar_Meetings_Title: "Filtre de dates",
  DateFilterBar_ShowMeetings: "Montre les séances à partire du",
  DefaultDuration: "Durée",
  DefaultLocation: "Lieu",
  DefaultRemarks: "Remarques",
  DefaultTemplates_Description: "La configuration standard de l'application est installée par l'équipe de développement de SiVe avec l'application. Les corrections des modèles sont ainsi automatiquement mises à jour pour toutes les organes.",
  DefaultTemplates_Title: "Modèles",
  DefaultTime: "Heure de début",
  Deleted: "Supprimé",
  DeputyMember: "Membres suppléants",
  DeputyVisitor: "Visiteurs suppléants",
  Description: "Description",
  DismissableDialog_Close_Label: "Fermer",
  DismissableDialog_Close_Tooltip: "Ne plus afficher le message",
  Document_Action_Title: "Action",
  Document_Add_Uploading: "Le document est en cours de téléchargement …",
  Document_Confidential_Title: "Strictement confidentiel",
  Document_FileSize_Title: "Taille",
  Document_Modified_Title: "Actualisé",
  Document_Modified_Tooltip: "Date de modification du point de l'ordre du jour ou du dossier",
  Document_Title_Title: "Titre",
  Document_Title_Tooltip: "Nom du point ou du fichier",
  Documents_Loading: "Chargement des documents …",
  Documents_NavBar_Refresh: "Actualisier",
  Documents_NavBar_Sync_Description: "Sélectionne une actions dans la colone Action pour les points ou pour les documents et exécute celle-ci au moyen du bouton Sychroniser",
  Documents_NavBar_Sync_Submitting: "Synchronise les documents …",
  Documents_NavBar_Sync_Title: "Aide pour Sychronisation",
  Documents_NavBar_ToggleNav: "Visualiser/Cacher la navigation",
  Documents_NavBar_View: "Vue",
  Documents_Refreshing: "Actualiser les documents …",
  Documents_Secret: "Documents supplémentaires",
  DocumentsForm_None: "Pas de",
  DocumentsList_Empty: "Aucun point n'a été saisi.",
  DocumentsPanel_Description: "Les fichiers suivants ont été téléchargés pour ce point de l'ordre du jour",
  DocumentsPanel_Header: "Documents",
  DocumentsPanel_Loading: "Chargement des documents …",
  DocumentStatus_Default: "Actif",
  DocumentStatus_Deleted: "Supprimé",
  Edecide: "eDecide",
  Edecide_NoBoardLinked: "Actuellement, aucun organe eDecide n'est lié à cette instance.",
  Edecide_RunManagementUrl: "Modifier l'activité",
  Edecide_RunUrl: "Détails de l'activité",
  EdecidePanel_CreateRun_Failure: "L'activité n'a pas pu être créée.",
  EdecidePanel_CreateRun_Failure_NotFound: "L'organe eDecide n'existe pas. Vérifie l'identifiant de l'organe eDecide dans les préférences.",
  EdecidePanel_CreateRun_Success: "Activité créée",
  EdecidePanel_DuplicateRuns: "Activités existants trouvés",
  EdecidePanel_DuplicateRuns_Text: "Il existe au moins un activité eDecide avec cet ID externale. Si les données doivent être à nouveau transférées depuis Sive, il faut d’abord supprimer les doublons.",
  EdecidePanel_Header: "Activité eDecide",
  EdecidePanel_Loading: "Chargement de l'aperçu …",
  EdecidePanel_OverrideTitle: "Titre",
  EdecidePanel_OverrideTitle_HelpContent: "Le titre de l'activité à créer dans eDecide peut être remplacé dans ce champ. Cela ne devrait être nécessaire que dans des cas exceptionnels. Le contrôle des doublons n’est pas effectué par le titre, mais par l’ID externe.",
  EdecidePanel_OverrideTitle_HelpTitle: "Remplacer le titre d'activité",
  EdecidePanel_Participant_Name: "Nom",
  EdecidePanel_Participants: "Participants",
  EdecidePanel_Submit: "Créer une activité",
  EdecidePanel_Submitting: "Création d'une activité dans eDecide …",
  EdecidePanel_Topic_Title: "Titre",
  EdecidePanel_Topic_Type: "Type",
  EdecidePanel_Topics: "Ordre du jour (affaires)",
  EdecidePanel_UniqueId: "ID externe",
  EdecideStatus_CompleteRunFailure: "L'activité n'a pas pu être terminée.",
  EdecideStatus_CompleteRunSuccess: "L'activité s'est terminée avec succès.",
  EdecideStatus_CompletingRun: "L'activité sera terminée …",
  EdecideStatus_CreateRunFailure: "L'activité n'a pas pu être créée.",
  EdecideStatus_CreateRunSuccess: "L'activité a été créée avec succès",
  EdecideStatus_CreatingRun: "L'activité sera créée …",
  EdecideStatus_Empty: "Aucune activité n'a encore été lancée.",
  EdecideType_Decision: "Décision",
  EdecideType_Decision_Tooltip: "Ce point de l'ordre du jour est transmis à eDecide en tant que Demande",
  EdecideType_Default: "-",
  EdecideType_Information: "Information",
  EdecideType_Information_Tooltip: "Ce point de l'ordre du jour est transmis à eDecide en tant que Information",
  EditAgendaItemPanel_Header: "Editer le point de jour",
  EditBoardPanel_Header: "Editer organe",
  EditMeetingPanel_Header: "Modifier la séance",
  EditParticipantPanel_Header: "Modifier participants",
  EditTaskPanel_Header: "Modifier tâche",
  Email: "Email",
  EmptyTable: "Aucune donnée disponible dans le tableau",
  Entity: "Entité",
  Entity_Add_Failure: "{EntityName} n'a pas pu être créé.",
  Entity_Add_Success: "{EntityName} créé avec succès.",
  Entity_Delete_ConfirmContent: "Veux-tu vraiment supprimer {EntityName} ?",
  Entity_Delete_ConfirmTitle: "Confirmer la suppression",
  Entity_Delete_Failure: "{EntityName} n'a pas pu être supprimé.",
  Entity_Delete_Success: "{EntityName} a été supprimé avec succès.",
  Entity_IsDeleted_Description: "Ce bloc de données est supprimé (statut: supprimé). Le bloc de données peut généralement être réactivé en définissant un autre statut que celui supprimé.",
  Entity_IsDeleted_Title: "Est effacé",
  Entity_Patch_Failure: "Ta demande n'a pas pu être traitée, merci de réessayer.",
  Entity_Patch_SuccessNoChanges: "Ta demande a été traitée, mais aucun changement n'a été détecté.",
  Entity_Patch_Unauthorized: "Tu n'es pas autorisé à effectuer cette adaptation.",
  Entity_Refresh_Failure: "{EntityName} n'a pas pu être rechargé.",
  Entity_Refresh_Success: "{EntityName} a été rechargé avec succès.",
  Entity_Save_Failure: "{EntityName} n'a pas pu être enregistré.",
  Entity_Save_Success: "{EntityName} sauvegardé avec succès.",
  Entity_Update_Failure: "{EntityName} n'a pas pu être mis à jour.",
  Entity_Update_Success: "{EntityName} mis à jour avec succès.",
  EntityCount: "# Entrées",
  EntityTitle_Unknown: "Inconnu",
  Error_FailedToAddUser: "L'utilisateur '{0}' n'a pas pu être ajouté.",
  ErrorCodes_BadRequest: "Quelque chose a échoué dans la requête. Il s'agit d'une erreur client (par exemple: syntaxe de requête erronée, encadrement invalide du message de requête ou routage de requête trompeur).",
  ErrorCodes_InternalServerError: "Une erreur s'est produite lors du traitement de ta demande.",
  ErrorCodes_NoResponse: "Le service backend n'est pas disponible.",
  ErrorCodes_NotFound: "La ressource n'a pas été trouvée.",
  ErrorCodes_Unauthorized: "Tu n'as pas accès à la ressource.",
  ErrorDialog_AppInsights: "Les propriétés suivantes permettent d'analyser l'erreur survenue sur les App Insights dans le portail Azure (Investigate > Search > Filter). Veuillez ajouter ces propriétés lors de la création de l'incident.",
  ErrorDialog_AppInsights_Date: "Moment",
  ErrorDialog_AppInsights_OperationId: "Opération",
  ErrorDialog_AppInsights_SessionId: "Séance",
  ErrorDialog_AppInsights_UserId: "Utilisateur",
  ErrorDialog_AuthFailure_Text: "Pendant l'execution de la demande une erreur d'authentification à eu lieu. Recharge la page et réessaye encore une fois.",
  ErrorDialog_AuthFailure_Title: "Erreur d'authentification",
  ErrorDialog_ComponentFailure_Text: "Une erreur à eu lieu dans l'interface utilisateur. Controle le message d'erreur dans la console de ton navigateur (F12)",
  ErrorDialog_ComponentFailure_Title: "Erreur d'interface utilisateur",
  ErrorDialog_ForbiddenFailure_Text: "Tu n'a pas de droits d'accès pour effectuer cette action ou pour accéder à cette ressource.",
  ErrorDialog_ForbiddenFailure_Title: "Accès refusé",
  ErrorDialog_NotFoundFailure_Text: "Le bloc de données est introuvable. Il est possible qu’il ait été supprimé entre-temps par un autre utilisateur ou qu’une combinaison de paramètres non valide ait été utilisée. Merci de réessayer.",
  ErrorDialog_NotFoundFailure_Title: "Pas trouvé",
  ErrorDialog_OneDrive_Text: "Une erreur générale OneDrive à eu lieu. Contactez le support IT.",
  ErrorDialog_OneDrive_Title: "Erreur OneDrive",
  ErrorDialog_OneDriveMissingSource_Title: "Erreur OneDrive",
  ErrorDialog_OneDriveNotFound_Text: "OneDrive n'est pas disponible pour ton compte. Contacte le support IT.",
  ErrorDialog_OneDriveNotFound_Title: "Erreur OneDrive",
  ErrorDialog_OneDrivePermissionsDenied_Text: "Tu n'est pas un participant de cette séance, de ce fait, cette fonction n'est pas disponible pour toi.",
  ErrorDialog_OneDrivePermissionsDenied_Title: "Pas de droits pour synchroniser sur OneDrive",
  ErrorDialog_ServerFailure_Text: "Pendant l'execution de la demande une erreur de serveur est survenue. Actualise la page et reessaie.",
  ErrorDialog_ServerFailure_Title: "Erreur de serveur",
  ErrorDialog_UnknownFailure_Text: "Pendant l'execution de la demande une erreur inconnue est survenue. Actualisez la page et réessayez.",
  ErrorDialog_UnknownFailure_Title: "Erreur inconue",
  Exception: "Exception",
  Exists: "Existe",
  Extended_Mode: "Mode avancé",
  File: "Fichier",
  FileAction_Delete: "Sera supprimé",
  FileAction_Existing: "Existant",
  FileAction_New: "Sera téléchargé",
  FileAction_Overwrite: "Sera écrasé",
  FileCount_Tooltip: "Nombre de documents",
  FileName: "Nom de fichier",
  FileSize: "Taille du fichier",
  Filter_Combobox_Filter_Customize: "Filtre",
  Filter_Keywords_Description: "Recherche de mots-clés dans le tableau",
  FilterToggle_ShowAgendaItems: "Visualiser points",
  FilterToggle_ShowAgendaItems_Description: "Affiche les points à l’ordre du jour des organes et séunces étendus.",
  FilterToggle_ShowAgendaItems_Title: "Visualiser points",
  FirstName: "Prénom",
  FolderName: "Dossier",
  Footer_Help: "Aide",
  Footer_HelpTitle: "SBB eDecide Aide",
  Footer_Imprint: "Mentions légales",
  Footer_Support: "Support",
  Footer_Title: "Mentions légales et aide",
  GeneratedDocuments_Description: "Contient les documents générés de l'organe (menu de sortie)",
  GeneratedDocuments_Title: "Documents générés",
  GeneratorVariable_AgendaItem: "Point de l'ordre du jour",
  GeneratorVariable_NoAgendaItems: "Pas d'ordre du jour trouvé",
  GeneratorVariable_Nr: "No.",
  GeneratorVariable_ParticipantWithRoleNotFound: "Aucun participant n'a été trouvé avec le rôle '{0}' !",
  GeneratorVariable_SeeConfidentialProtocol: "Voir procès-verbal (strictement confidentiel)",
  GeneratorVariable_When: "Quand",
  GeneratorVariable_Who: "Qui",
  GridWorksConfig_Description: "Contient la configuration et les modèles de l'l'organe",
  GridWorksConfig_Title: "Configuration",
  Group: "Groupe",
  Group_Add: "Ajouter un groupe",
  Group_AddError: "Le groupe n'a pas pu être ajouté",
  Group_AddSuccess: "Le groupe a été ajouté avec succès",
  Group_CleanupDeletedUsers: "Le groupe contient {0} utilisateurs et utilisatrices supprimés. Merci de corriger ces entrées!",
  Group_ConfirmDelete: "Tu veux vraiment supprimer le groupe?",
  Group_DeleteError: "Le groupe n'a pas pu être supprimé",
  Group_EntraIdName: "Nom dans Entra ID",
  Group_EntraIdName_Description: "Si tu associes ici un groupe Entra ID (Omada), les membres sont importés périodiquement. Si aucune liaison n’est définie, les membres peuvent être supprimés et ajoutés à droite.",
  Group_Id: "Nom",
  Group_MemberCount: "No. membres",
  Group_Members: "Membres",
  Group_Name: "Nome",
  Group_Search: "Recherche de groupe …",
  Group_SearchStringHint: "Il s'agit du nom du groupe AD pris en charge.",
  Group_Titles: "Groupes AD",
  GroupMember_ExistsInGroup: "Existe en groupe",
  Groups: "Groups",
  Header_English: "English",
  Header_French: "Français",
  Header_German: "Deutsch",
  Header_Help: "Aide",
  Header_Italian: "Italiano",
  Header_SettingsMenu: "Configurations",
  Header_SettingsMenu_Cache: "Voir le cache",
  Header_SettingsMenu_EditBoard: "Modifier la configuration",
  Header_SettingsMenu_ViewBoard: "Voir le configuration",
  Header_UserMenu: "Utilisateur actuel",
  Header_UserMenu_OneDrive: "OneDrive",
  Header_UserMenu_Profile: "Mon compte",
  Header_UserMenu_SignOut: "Se déconnecter",
  Header_Version: "Version",
  Help: "Aide",
  HelpMenu_CosProductPage: "Produit COS eGPL 2",
  HelpMenu_Manuals: "Manuels",
  HelpMenu_Support: "Support",
  HelpMenu_VivaEngage: "Groupe Viva Engage eGPL 2",
  History: "Historique",
  Home: "Accueil",
  Id: "ID",
  ImportedFromPhonebook: "Champs importées de l'annuaire téléphonique",
  Info: "Affichage de _START_ à _END_ sur _TOTAL_ éléments",
  InfoFiltered: "(filtré à partir de _MAX_ éléments au total)",
  Initials: "Initiales",
  Initials_HelpText: `Si tu laisses le champ vide, le standard sera appliqué.<br/>
Première lettre du prénom, première lettre du nom de famille.`,
  Initials_Preview: "Aperçu",
  KendoReactGrid_CalendarToday: "Aujourd'hui",
  KendoReactGrid_FilterAfterOperator: "Est après",
  KendoReactGrid_FilterAfterOrEqualOperator: "Est égal ou postérieur à",
  KendoReactGrid_FilterBeforeOperator: "Est avant",
  KendoReactGrid_FilterBeforeOrEqualOperator: "Est antérieur ou égal à",
  KendoReactGrid_FilterBooleanAll: "(Tous)",
  KendoReactGrid_FilterContainsOperator: "Contient",
  KendoReactGrid_FilterDoesNotContain: "Ne contient pas",
  KendoReactGrid_FilterEndWith: "Se termine par",
  KendoReactGrid_FilterEqOperator: "Correspond à",
  KendoReactGrid_FilterGteOperator: "Est supérieur ou égal à",
  KendoReactGrid_FilterGtOperator: "Est supérieur à",
  KendoReactGrid_FilterIsEmpty: "Est vide",
  KendoReactGrid_FilterIsFalse: "Est faux",
  KendoReactGrid_FilterIsNotEmpty: "N'est pas vide",
  KendoReactGrid_FilterIsNotEqualTo: "N'est pas égale à",
  KendoReactGrid_FilterIsNotNull: "N'est pas nul",
  KendoReactGrid_FilterIsNull: "Est nul",
  KendoReactGrid_FilterIsTrue: "Est vrai",
  KendoReactGrid_FilterLteOperator: "Est inférieur ou égal à",
  KendoReactGrid_FilterLtOperator: "Est inférieur à",
  KendoReactGrid_FilterStartsWith: "Commence par",
  KendoReactGrid_NoRecords: "Aucune entrée disponible.",
  KendoReactGrid_PagerInfo: "{0} - {1} de {2} entrées",
  KeywordSearch: "Recherche par mots-clés",
  Language: "Langue",
  LastModified: "Dernière modification",
  LastModifiedBy: "Dernière modification par",
  LastName: "Nom de famille",
  LastSync: "Dernière synchronisation",
  Loading: "Chargement …",
  Loading_MeetingTemplates: "Charger des séances standard …",
  Logout: "Déconnexion",
  LongName: "Long longue",
  Meeting: "Séance",
  Meeting_AdditionalInfo_Description: "Texte ou lien d'informations supplémentaires",
  Meeting_AdditionalInfo_Title: "Informations supplémentaires",
  Meeting_AgendaItems_Warning_Tooltip: "L'ordre du jour de la séance standard a été mis à jour. Avec Actualiser l'ordre du jour, le standard peut être appliqué à cette séance.",
  Meeting_Difference_Title: "Différence",
  Meeting_DocumentStatus_ContextHelp_Title: "Documents de travail",
  Meeting_DocumentStatus_Description: "Affiche le nombre de documents associés à la séance.",
  Meeting_DocumentStatus_Title: "Documents de travail",
  Meeting_Duration_Title: "Temps nécessaire",
  Meeting_EdecideStatus_Description: "-",
  Meeting_EdecideStatus_RunManagementUrl: "Lien 'Modifier l'activité' dans eDecide",
  Meeting_EdecideStatus_RunUrl: "Lien 'Détails de l'activité' dans eDecide",
  Meeting_EdecideStatus_Status: "Statut de l'activité dans SiVe/eDecide",
  Meeting_EdecideStatus_Title: "Statut eDecide",
  Meeting_EndDate_Description: "Veuillez indiquer le date et l'heure de fin de la séance. L'heure de fin correspond à une heure de planification. Celle-ci sera comparée avec l'heure de fin effective. Sie l'heure planifiée est dépassée, un symbole rouge sera affiché pour l'indiquer. Sinon un symbole vert indiquera que le temps total n'a pas été dépassé.",
  Meeting_EndDate_Title: "Fin planifiée",
  Meeting_EventDate: "Date",
  Meeting_EventDate_Description: "Veuillez indiquer le date et l'heure de fin de la séance. L'heure de départ des points sera calculée automatiquement.",
  Meeting_EventDate_Title: "Date",
  Meeting_EventTime_Title: "Heure de départ planifiée",
  Meeting_IssueDate_Description: "Dans ce champ sera définie la date de soumission des documents pour la séance.",
  Meeting_IssueDate_Title: "Date de l'édition",
  Meeting_IsTemplate: "Est standard",
  Meeting_IsTemplate_Description: "Transforme la séance en séance par défaut, afin qu'elle puisse servir de modèle lors de la création de nouvelles séances. Si la séance est déjà une séance par défaut, elle peut être transformée à nouveau en séance standard.",
  Meeting_IsTemplate_Title: "Est standard",
  Meeting_Loading: "Chargement de la séance …",
  Meeting_Loading_EditForm: "Chargement du formulaire de la séance …",
  Meeting_Location_Description: "Veuillez indiquer le lieu et la salle de séance. Ordre des Informations: salle de séance, étage, rue et no., code postal et lieu",
  Meeting_Location_Title: "Lieu/Salle de séance",
  Meeting_Locked_Active_Tooltip: "La séance est fermée aux membres pour traitement.",
  Meeting_Locked_Description: "Veuillez bloquer la séance ici si nécessaire. Avec verrouillé, personne ne peut plus saisir de point à l'ordre du jour. Il est particulièrement utile pour les séances de réserve ou pour la planification et la gestion des affaires.",
  Meeting_Locked_Inactive_Tooltip: "La séance est ouverte à l'édition pour les membres.",
  Meeting_Locked_Title: "Bloqué",
  Meeting_New_Placeholder: "Nouvelle séance …",
  Meeting_Note_Description: "Veuillez indiquer ici les informations importantes, par exemple La séance à lieu à l'extérieur.",
  Meeting_Note_Title: "Commentaire",
  Meeting_PlannedEndTime_Title: "Heure de fin planifiée",
  Meeting_ProjectedEndTime: "Heure de fin effective",
  Meeting_ProjectedEndTime_Description: "-",
  Meeting_ProjectedEndTime_Title: "Heure de fin effective",
  Meeting_Status_Description: "Veuillez indiquer ici le statut de la séance",
  Meeting_Status_Title: "Statut",
  Meeting_SubmissionDate_Description: "Veuillez indiquer ici la date de soumission des documents requis.",
  Meeting_SubmissionDate_Title: "Date de soumission des documents préliminaires",
  Meeting_TemplateId_Title: "Séance standard",
  Meeting_Title_Description: "Veuillez utiliser le format suivant : AAAA-MM-JJ_abréviation réunion de l'organe (Exemple : 2019-08-12_KL-Session).",
  Meeting_Title_Title: "Titre",
  Meeting_UpdateParticipants_Warning_Tooltip: "Les participants de la séance standard ont été mis à jour. Avec Mettre à jour les participants, le standard peut être appliqué à cette séance.",
  Meeting_WorkingDocumentStatus_Title: "Documents de travail",
  Meeting_WorkingDocumentUrl_Description: "-",
  MeetingParticipants_Description: "Contient les participants d'une séance",
  Meetings: "Séances",
  Meetings_Description: "Contient les séances",
  Meetings_EmptyTable: "Aucune séance correspondant à tes critères n'a été trouvée.",
  Meetings_Loading: "Chargement des séances …",
  Meetings_Title: "Séances",
  MeetingStatus_Archived: "Archivé",
  MeetingStatus_Complete: "Terminé",
  MeetingStatus_Default: "En cours",
  MeetingStatus_Deleted: "Supprimé",
  MeetingStatus_Published: "Publié",
  MeetingStatus_Unknown: "Inconnu",
  Member: "Membres",
  Modified: "Actualisé",
  ModifiedBy: "Modifié par",
  More: "Plus",
  MoreEntries: "({0} entrées)",
  MultiSelect_AllSelected: "Tout sélectionné",
  MultiSelect_FilterPlaceholder: "Filtrer …",
  MultiSelect_NoneSelected: "Aucune sélection",
  MultiSelect_Reset: "Annuler la sélection",
  MultiSelect_SelectAll: "Sélectionner tout",
  MultiSelect_Selected: "sélectionné",
  MyRoles: "Mes rôles",
  Name: "Nom",
  Navigation_Administration: "Administration",
  No: "Non",
  NoTitle: "Aucun titre",
  OneDrive_Sync_Mismatch: "Des documents existent, lesquels n'ont pas encore été synchronisés pour la publication.",
  OneDriveDocument: "Document OneDrive",
  OneDriveSync_RemoteDocumentExistsUseOverwrite: "Le fichier OneDrive existe déjà pour {0}. Sélectionnez «Écraser» dans le menu déroulant des actions pour le remplacer.",
  OneDriveSync_RemoteFileNotUploaded: "Impossible de charger le document {0}. Erreur {1}",
  OneDriveSync_WorkingDocumentContentNotFound: "Impossible de charger le contenu du document de travail {0}!",
  OneDriveSync_WorkingDocumentDoesNotExist: "Le document de travail {0} n’existe pas!",
  OpenLinkNewWindow: "Ouvrir le lien (dans une nouvelle fenêtre)",
  OrganisationUnit: "Unité organisationnelle",
  OriginalPath: "Chemin de requête",
  OutputDocument: "Document de sortie",
  OutputDocument_AgendaItemConfirmedMail_Description: "Crée un modèle outlook, avec lequel on peut communiquer à la personne qui l'a soumis, que son point a été approuvé",
  OutputDocument_AgendaItemConfirmedMail_Title: "Confirmer le point",
  OutputDocument_AgendaItemDeferredMail_Description: "Crée un modèle outlook, avec lequel on peut communiquer à la personne qui l'a soumis, que son point a été reporté",
  OutputDocument_AgendaItemDeferredMail_Title: "Remise à zéro d'un point",
  OutputDocument_AgendaItemProtocolExtract_Description: "Crée un extrait de protocole dans le format Word",
  OutputDocument_AgendaItemProtocolExtract_Title: "Créer un extrait du protocole",
  OutputDocument_AgendaItemProtocolExtractMail_Description: "Crée un modèle outlook pour le point sélectionné, avec l'extrait du protocole dans le format PDF",
  OutputDocument_AgendaItemProtocolExtractMail_Title: "Envoyer un extrait du protocole",
  OutputDocument_AgendaItemProtocolExtractPdf_Description: "Crée un protocole dans le format PDF",
  OutputDocument_AgendaItemProtocolExtractPdf_Title: "Créer un extrait du protocole",
  OutputDocument_ApplyStandardMeeting_Description: "Choisis une séance standard et applique sur la séance existante.",
  OutputDocument_ApplyStandardMeeting_Title: "Appliquer une séance standard",
  OutputDocument_Description: "Description du document de sortie",
  OutputDocument_Language: "Langue",
  OutputDocument_Language_All: "Tout",
  OutputDocument_Language_None: "Pas de",
  OutputDocument_MeetingAgendaItems_Description: "Crée la liste des points à l'ordre du jour en format Excel",
  OutputDocument_MeetingAgendaItems_Title: "Points à l'ordre du jour",
  OutputDocument_MeetingClone_Description: "-",
  OutputDocument_MeetingClone_Title: "Copier la séance",
  OutputDocument_MeetingComplete_Description: "Ferme la séance actuelle. A partir de ce moment les possibilités de modifications sont limités",
  OutputDocument_MeetingComplete_Title: "Fermer la séance",
  OutputDocument_MeetingEdecide_Description: "Démarre une activité dans eDecide",
  OutputDocument_MeetingEdecide_Title: "Créer une activité eDecide",
  OutputDocument_MeetingFixate_Description: "Fixe la date de la séance actuelle. Depuis ce moment les numéros des points de l'ordre du jours sont fixés",
  OutputDocument_MeetingFixate_Title: "Fixer la séance",
  OutputDocument_MeetingInvitation_Description: "-",
  OutputDocument_MeetingInvitation_Title: "Créer l'invitations",
  OutputDocument_MeetingInvitationMail_Description: "Crée une invitation en tant que modèle outlook pour l'envoi aux participants",
  OutputDocument_MeetingInvitationMail_Title: "Envoyer l'invitation",
  OutputDocument_MeetingOneNote_Description: "-",
  OutputDocument_MeetingOneNote_Title: "Créer un OneNote",
  OutputDocument_MeetingOverview_Description: "Crée une liste des points du jour pour les participants (invitation)",
  OutputDocument_MeetingOverview_Title: "Créer la liste des points",
  OutputDocument_MeetingPresentationReminderMail_Description: "Crée un rappel pour soumettre les documents de séance, en tant que modèle outlook",
  OutputDocument_MeetingPresentationReminderMail_Title: "Envoyer un rappel pour les présentations",
  OutputDocument_MeetingProtocolConfidential_Description: "Crée un protocole en forme d'un fichier Word contenant les points du jour strictement confidentiel",
  OutputDocument_MeetingProtocolConfidential_Title: "Créer un protocole (strictement confidentiel)",
  OutputDocument_MeetingProtocolMail_Description: "Crée le protocole en tant que modèle Outlook",
  OutputDocument_MeetingProtocolMail_Title: "Envoyer le protocole",
  OutputDocument_MeetingProtocolNonConfidential_Description: "Crée le protocole en tant que fichier Word",
  OutputDocument_MeetingProtocolNonConfidential_Title: "Créer le protocole",
  OutputDocument_MeetingReminderMail_Description: "Crée un modèle outlook, avec lequel un rappel pour la soumission de documents peut être envoyé",
  OutputDocument_MeetingReminderMail_Title: "Envoyer le rappel",
  OutputDocument_MeetingSaveAsDefault_Description: "Indique la séance standard actuelle de l'organe avec l'ordre du jour et les participants en vigueur lors de cette séance.",
  OutputDocument_MeetingSaveAsDefault_Title: "Enregistrer comme standard",
  OutputDocument_MeetingUpdateAgendaItems_Confirm: "Tous les points de l'ordre du jour, à l'exception de ceux qui ont été ajoutés manuellement, sont supprimés et l'ordre du jour de la séance standard est appliqué.",
  OutputDocument_MeetingUpdateAgendaItems_Confirm_Title: "Actualiser l'ordre du jour ?",
  OutputDocument_MeetingUpdateAgendaItems_Description: "Tous les points de l'ordre du jour, à l'exception de ceux qui ont été ajoutés manuellement, sont supprimés et l'ordre du jour de la séance standard est appliqué.",
  OutputDocument_MeetingUpdateAgendaItems_Title: "Actualiser l'ordre du jour",
  OutputDocument_MeetingUpdateParticipants_Confirm: "Tous les participants, à l'exception de ceux qui ont été ajoutés manuellement, sont supprimés et la liste des participants de la séance  standard est appliquée.",
  OutputDocument_MeetingUpdateParticipants_Confirm_Title: "Actualiser les participants ?",
  OutputDocument_MeetingUpdateParticipants_Description: "Tous les participants, à l'exception de ceux qui ont été ajoutés manuellement, sont supprimés et les participants de la séance standard sont appliqués.",
  OutputDocument_MeetingUpdateParticipants_Title: "Actualiser la liste des participants",
  OutputDocument_Name: "Document de sortie",
  OutputDocument_Task_Description: "Ouvrir les points en suspens",
  OutputDocument_Task_Title: "Ouvrir les points en suspens",
  OutputDocument_WorkingDocumentsExportFolders_Description: "Crée une archive avec tous les documents le la séance actuelle",
  OutputDocument_WorkingDocumentsExportFolders_Title: "Exporter les documents de travail (zip)",
  OutputDocuments_Button_AgendaItem: "Point actuell",
  OutputDocuments_Button_Meeting: "Séance actuelle",
  OutputDocuments_Empty: "Aucun document n'a été crée.",
  OutputDocuments_FolderUrl: "Les documents suivants ont été créés avec succés",
  OutputDocuments_Header: "Création de documents",
  OutputDocuments_Loading: "Créer les documents …",
  OutputDocuments_Success: "Enregistré avec succès",
  OutputDocuments_Table_Name: "Nom du document",
  OutputDocuments_Table_Size: "Dimension",
  Owner: "Propriétaire",
  Page_About_Title: "À propos de SiVe",
  Page_Admin_Title: "Administration",
  Page_Administration_Title: "Administration",
  Page_AgendaItem_Title: "Point «{0}»",
  Page_AgendaItems_Title: "Points",
  Page_Board_Title: "Organe «{0}»",
  Page_BoardCache_Title: "Cache de l'organe",
  Page_BoardEdit_Title: "Modifier organe «{0}»",
  Page_Boards_Title: "Organe",
  Page_BoardSetup_Title: "Mise en place de l'organe",
  Page_BoardTemplates_Title: "Modèles d'organes",
  Page_Cache_Title: "Cache",
  Page_Claims_Title: "User claims",
  Page_Dashboard_Description: "Les séances planifiées de tous les organes seront affichées sur le tableau de board. Avec le filtre de dates ont peux modifier la période d'affichage (La configuration de base est la date actuelle moins 10 jours). Tous les organes et les séances affichés peuvent être ouverts au moyen d'un clic.",
  Page_Dashboard_Title: "Tableau de bord",
  Page_Default_Title: "Vue globale",
  Page_DetailedDashboard_Title: "Vue d'ensemble séances et points de l'ordre du jour",
  Page_Document_Title: "Document",
  Page_Documents_Title: "Documents",
  Page_Error_SubTitle: "Une erreur s'est produite lors du traitement de votre demande.",
  Page_Error_Title: "Erreur",
  Page_Group_Title: "Groupe «{0}»",
  Page_Groups_Title: "Groups",
  Page_Impersonate_Title: "Adopter une identité",
  Page_JobStatus_Title: "Statut du travail",
  Page_Mails_Title: "Test d'Inxmail",
  Page_Meeting_Title: "Séance",
  Page_MeetingName_Title: "Séance «{0}»",
  Page_Meetings_Title: "Séances",
  Page_Memory_Title: "Memoire",
  Page_OneDriveSync_Title: "Synchronisation OneDrive",
  Page_Participant_Title: "Participant «{0}»",
  Page_Participants_Title: "Participants",
  Page_Resources_Title: "Traductions",
  Page_SendTo_Title: "Envoyer à",
  Page_Settings_Title: "Configurations",
  Page_Setup_Title: "Configuration",
  Page_SignOut_Title: "Déconnexion",
  Page_StandardMeetingName_Title: "Séance standard «{0}»",
  Page_StaticCache_Title: "Cache statique",
  Page_Task_Title: "Tâche «{0}»",
  Page_Tasks_Title: "Tâches",
  Page_Translations_Title: "Traductions",
  Page_User_Title: "Utilisateur «{0}»",
  Page_UserEdit_Title: "Modifier l'utilisateur «{0}»",
  Page_UserPreferences_Title: "Préférences",
  Page_Users_Title: "Utilisateurs",
  Pagination_First: "Premier",
  Pagination_Last: "Dernier",
  Pagination_Next: "Suivant",
  Pagination_Previous: "Précédente",
  Paging_First: "Premier",
  Paging_Items: "éléments",
  Paging_Last: "Dernier",
  Paging_Next: "Suivant",
  Paging_Of: "de",
  Paging_OutOfBounds: "Les paramètres (skip*take) dépassent le nombre de résultats disponibles.",
  Paging_Page: "Page",
  Paging_Previous: "Précédente",
  Paging_SkipTooLarge: "Les paramètres (skip*take) dépassent le nombre de résultats disponibles.",
  Paging_TotalFiltered1: "1 éléments",
  Paging_TotalFilteredN: "{0} éléments",
  Paging_TotalUnfiltered: "(filtré à partir de {0} éléments au total)",
  PagingFirst: "Premier",
  PagingLast: "Dernier",
  PagingNext: "Suivant",
  PagingPrevious: "Précédente",
  Participant: "Participant",
  Participant_Add_ContextHelp_Title: "-",
  Participant_Add_Description: "-",
  Participant_Add_Submitting: "Créer les participants …",
  Participant_Add_Success: "Le participant a été ajouté(e)",
  Participant_CanSeeConfidential_Description: "Choisir si le participant peut voir les documents confidentiels",
  Participant_CanSeeConfidential_Title: "Afficher les documents strictement confidentiels",
  Participant_Loading: "Charger du participant …",
  Participant_Loading_EditForm: "Chargement du formulaire des participants …",
  Participant_NavBar_AddParticipant: "Ajouter",
  Participant_NavBar_ToggleNav: "Visualiser/Cacher la navigation",
  Participant_Person_Title: "Personne",
  Participant_Position_Description: "-",
  Participant_Position_Title: "Position",
  Participant_Remarks_Description: "Remarques concernant le participant",
  Participant_Remarks_Title: "Commentaire",
  Participant_Remove_Success: "Le participant a été supprimé",
  Participant_Role_Description: "Séléctionner Présidence ou Protocole.  Le rôle Membre sera attribué par défaut.",
  Participant_Role_Title: "Role",
  Participant_Status_Description: "Sélectionne le statut de la participante",
  Participant_Status_Title: "Statut",
  Participant_User_Description: "Choisis un membre de l'organe",
  Participant_User_Title: "Personne",
  ParticipantRole_Chair: "Présidence",
  ParticipantRole_NoDataTemplate: "Aucun rôle trouvé",
  ParticipantRole_Placeholder: "Sélectionne le rôle …",
  ParticipantRole_Protocol: "Protocole",
  Participants: "Participants",
  Participants_Description: "Contient les participants de l'organe",
  Participants_Loading: "Charger les participants …",
  Participants_NavBar_View: "Vue",
  Participants_Title: "Participants",
  ParticipantsDetail_Empty: "Veuillez sélectionner un participant",
  ParticipantsList_Empty: "Aucun participant n'a été saisi",
  ParticipantStatus_Deleted: "Supprimé",
  ParticipantStatus_Excused: "Excusé",
  ParticipantStatus_Present: "Présent",
  ParticipantStatus_Unexcused: "Absence injustifiée",
  ParticipantStatus_Unknown: "Inconnu",
  Permission_Add_Error: "L'autorisation n'a pas pu être ajoutée : {0}",
  Permission_Add_Success: "L'autorisation a été ajoutée",
  Permission_Remove_Error: "L'autorisation n'a pas pu être supprimée : {0}",
  Permission_Remove_Success: "L'autorisation a été supprimée",
  Permissions: "Droits d'accès",
  Personalisation: "Personnalisation",
  PersonalSiteUrl: "URL du MySite SharePoint (OneDrive)",
  PersonnelNumber: "N° de personnel",
  Phone: "Téléphone",
  Phonebook: "Annuaire téléphonique",
  PhonebookLastSync: "Dernière synchronisation",
  Placeholder: "caractère de remplissage",
  Properties: "Propriétés",
  PublishedDocuments: "Documents publiés",
  PublishedDocuments_Description: "Contient les documents publiés de l'organe.",
  PublishingDocuments_Tooltip: "-",
  ReadMore_Less: "Aficher moins …",
  ReadMore_More: "Aficher plus …",
  RequestId: "ID de requête",
  RichText_Link_Dialog_Title: "Modifier lien",
  RichText_Link_Invalid_URL: "Prière d’entrer une URL valide (https://, http://, mailto:)",
  RichText_Link_Remove: "Supprimer lien",
  RichText_Link_Text_Label: "Texte affiché",
  RichText_Link_URL_Label: "Objectif",
  RichText_Paste_Cancel_Tooltip: "Annuler (annuler le collage)",
  RichText_Paste_KeepFormatting_Tooltip: "Conserver la mise en forme",
  RichText_Paste_Options_Trigger_Tooltip: "Options de collage (Ctrl)",
  RichText_Paste_PlainText_Tooltip: "Insérer en texte brut",
  Richtext_Placeholder: "Saisir texte …",
  RichText_Tooltip_Background: "Couleur de fond",
  RichText_Tooltip_Blockquote: "Appliquer en format de justification",
  RichText_Tooltip_Bold: "Gras (CTRL+B)",
  RichText_Tooltip_Clean: "Supprimer le format",
  RichText_Tooltip_Color: "Couleur du texte",
  RichText_Tooltip_Heading: "Titre",
  RichText_Tooltip_Indent_Minus1: "Reduire l'intendation (Shift+Tab)",
  RichText_Tooltip_Indent_Plus1: "Augmenter l'intendation (Tab)",
  RichText_Tooltip_Italic: "Italique (Ctrl+I)",
  RichText_Tooltip_Link: "Ajouter un lien",
  RichText_Tooltip_List_Bullet: "Ajouter une liste",
  RichText_Tooltip_List_Ordered: "Ajouter une liste numérotée",
  RichText_Tooltip_Script_Sub: "Indice",
  RichText_Tooltip_Script_Super: "Exposant",
  RichText_Tooltip_Size: "Grandeur du texte",
  RichText_Tooltip_Source: "Afficher le code source HTML",
  RichText_Tooltip_Strike: "Barré",
  RichText_Tooltip_Underline: "Souligner (Ctrl+U)",
  Run: "Activité",
  Runs: "Activités",
  Save: "Enregistrer",
  SelectAll: "Sélectionner tout",
  Selected_Actions: "Actions sélectionnées",
  SendTo_Add_Error: "La connection n'a pas pu être ajoutée : {0}",
  SendTo_Add_Success: "La connexion a été ajoutée",
  SendTo_AddIncoming: "Ajouter un organe source",
  SendTo_AddOutgoing: "Ajouter un organe cible",
  SendTo_Incoming: "Connexions entrantes",
  SendTo_Outgoing: "Connexions sortantes",
  SendTo_Remove_Error: "La connection n'a pas pu être supprimée : {0}",
  SendTo_Remove_Success: "La connexion a été supprimée",
  SendtoPanel_Committee: "Organe",
  SendtoPanel_Description: "Sélectionne une ou plusieurs organes ainsi que leurs séances et exécute  l'action Envoyer.",
  SendtoPanel_Header: "Envoyer à",
  SendtoPanel_Loading: "Chargement des organes …",
  SendtoPanel_Meeting: "Séance",
  SendToPanel_Meeting_NoDataTemplate: "Pas trouvé de séances",
  SendToPanel_Meeting_Placeholder: "Sélectionner la séance …",
  SendtoPanel_Submit: "Envoyer",
  SendtoPanel_Submitting: "Envois les points aux organes sélectionnés …",
  SendtoPanel_Success: "Les points ont été envoyés avec succès.",
  SendtoPanel_Title: "Aide pour Envoyer à",
  SendToTargets: "Envoyer-aux organes cibles",
  ShortName: "Nom abrégé",
  ShowDeleted: "Afficher les éléments supprimés",
  ShowInactive: "Afficher les éléments inactifs",
  ShowPermissions: "Afficher les autorisations",
  SignatureFirstName: "Prenom de la signature",
  SignatureFirstName_Undefined: "Le paramètre 'Signature prénom' n'est pas défini dans l'organe !",
  SignatureLastName: "Nom de famille de la signature",
  SignatureLastName_Undefined: "Le paramètre 'Signature du nom de famille' n'est pas défini dans l'organe !",
  StandardAgendaItems: "Ordre du jour standards",
  StandardMeeting_Apply_Error: "La séance standard n'a pas pu être appliquée : {0}",
  StandardMeeting_Apply_Success: "La séance standard a été appliquée avec succès.",
  StandardMeeting_Empty: "Vide",
  StandardMeeting_Old: "Ancien modèle (sera bientôt supprimé!)",
  StandardMeetingsPanel_Description: "Choisis une séance standard et applique les attributs de la séance, les ordres du jour et les participants sur la séance existante. Seules les séances dont l'attribut \"Est par défaut\" est activé sont proposées (voir onglet \"Séance\").",
  StandardMeetingsPanel_Header: "Appliquer séance standard",
  StandardMeetingsPanel_Preview_Loading: "Chargement de l'aperçu …",
  StandardMeetingsPanel_Submit: "Appliquer",
  StandardParticipants: "Participants standards",
  Statistics: "Statistiques",
  Statistics_Loading: "Chargement des statistiques…",
  Status: "Statut",
  StatusCode_401_SubTitle: "Vous n'avez pas accès à la ressource.",
  StatusCode_401_Title: "Accès refusé",
  StatusCode_403_SubTitle: "Vous n'avez pas la permission d'accéder à la ressource.",
  StatusCode_403_Title: "Interdit",
  StatusCode_404_SubTitle: "La ressource n'a pas été trouvée.",
  StatusCode_404_Title: "Pas trouvé",
  SuggestedAgendaItem_MeetingId_Title: "Séance",
  SuggestedAgendaItems: "Points soumis",
  SuggestedAgendaItems_Delete: "Supprimer",
  SuggestedAgendaItems_Delete_Success: "Les éléments sélectionnés ont été supprimés.",
  SuggestedAgendaItems_Deleting: "Supprimer les éléments sélectionnés …",
  SuggestedAgendaItems_Description: "Contient les points déposés à l'ordre du jour de ce organe",
  SuggestedAgendaItems_Filter: "Limiter",
  SuggestedAgendaItems_Loading: "Chargement des points proposés …",
  SuggestedAgendaItems_Meeting: "Séance",
  SuggestedAgendaItems_Meeting_Tooltip: "La séance proposée du point soumis. Ceci est un avis informel de la personne qui a soumis le point. Des éléments sélectionnés seront toujours ajoutés à la séance aktuelle.",
  SuggestedAgendaItems_Move: "Ajouter",
  SuggestedAgendaItems_Move_Success: "Les éléments sélectionnés ont été ajoutés à la séance actuelle.",
  SuggestedAgendaItems_Selection: "-",
  SuggestedAgendaItems_Selection_Tooltip: "Les points soumis peuvent être sélectionnés ici. Après la sélection vous pourrez exécuter les actions Ajouter et Supprimer.",
  SuggestedAgendaItems_Submitting: "Les éléments sélectionnés seront ajoutés à la séance aktuelle …",
  SuggestedAgendaItems_Title: "Titre",
  SuggestedAgendaItems_Title_Tooltip: "Le titre du point soumis",
  SuggestedAgendaItemsPanel_Header: "Points soumis",
  Table: "Tableau",
  Table_NoRows: "Aucun record trouvé.",
  Target: "destination",
  Task: "Tâche",
  Task_AgendaItem_Description: "-",
  Task_AgendaItem_Title: "Point",
  Task_AssignedTo_Description: "-",
  Task_AssignedTo_Title: "Assigné à",
  Task_Description_Description: "-",
  Task_Description_Title: "Description",
  Task_DueDate_Description: "-",
  Task_DueDate_Title: "Date d'échéance",
  Task_Meeting_Description: "-",
  Task_Meeting_Title: "Séance",
  Task_NavBar_AddTask: "Ajouter",
  Task_NavBar_ToggleNav: "Visualiser/Cacher la navigation",
  Task_NotAssigned: "Non attribué",
  Task_Source_Description: "-",
  Task_Source_Title: "Source",
  Task_StartDate_Description: "-",
  Task_StartDate_Title: "Date de départ",
  Task_Status_Description: "-",
  Task_Status_Title: "Statut",
  Task_Title: "Titre",
  Task_Title_Title: "Titre",
  Task_Title_Tooltip: "Titre",
  Task_Validate_IsLonger_Title: "Le champ titre ne peut contenir plus de 255 caractères",
  TaskFilterToggle_Description: "Le tableau de bord n'affiche que les tâches en suspens attribuées à l'utilisateur actuel.",
  TaskFilterToggle_Title: "Seulement mes tâches",
  TaskGrid_ItemId: "ID",
  TaskGrid_ItemId_Tooltip: "L'id de la tâche",
  TaskList_Empty: "Aucune tâche n'a été saisie",
  Tasks: "Tâches",
  Tasks_Add: "Ajouter",
  Tasks_Description: "Contient les tâches d'une séance",
  Tasks_Loading: "Chargement des tâches …",
  Tasks_Loading_EditForm: "Je charge le formulaire des tâches …",
  TasksDetail_Empty: "S'il te plaît sélectionne une tâche",
  TaskStatus_Archived: "Archivé",
  TaskStatus_Complete: "Terminé",
  TaskStatus_Default: "En cours",
  TaskStatus_Deferred: "Retenu",
  TaskStatus_InProgress: "En cours",
  TaskStatus_NotStarted: "Pas commencé",
  TaskStatus_WaitingOnSomeoneElse: "Attendre quelqu'un d'autre",
  TaskToggle_Description: "Affiche les tâches pour toutes les séances.",
  TaskToggle_Title: "Afficher les tâches",
  Template_Remove_Error: "La modèle n'a pas pu être supprimée : {0}",
  Template_Remove_Success: "La modèle a été supprimée",
  Templates: "Modèles",
  Templates_ValidFileNames: "Nom de fichiers valides",
  TemplatesDescription: "La configuration standard de l'application est installée par l'équipe de développement de SiVe avec l'application. Les corrections des modèles sont ainsi automatiquement mises à jour pour toutes les instances de la gestion des séances.",
  TenantName_Help: "Le nom de l'organe est utilisé dans les modèles de documents et dans l'interface utilisateur de la gestion des séances. Les valeurs habituelles sont le nom complet de l'organe, comme Conseil d'administration ou Direction du groupe.",
  TimePicker_Hours: "Heures",
  TimePicker_Minutes: "Minutes",
  Title: "Titre",
  Toast_Error: "Erreur",
  Toast_Success: "Succès",
  Toast_Warning: "Alerte",
  Total: "Totale",
  Upload_Choose: "Sélectionner les fichiers …",
  Upload_ClearSelectedFiles: "Supprimer les fichiers sélectionnés",
  Upload_DefaultDropZoneNote: "…",
  Upload_DropFilesHere: "Dépose des fichiers ici pour les télécharger …",
  Upload_DropZoneHint: "Dépose des fichiers ici pour les télécharger …",
  Upload_DropZoneNote: "Seuls les fichiers {0} sont autorisés.",
  Upload_Files: "Fichiers",
  Upload_HeaderStatusUploaded: "achevé",
  Upload_HeaderStatusUploading: "Télécharger…",
  Upload_InvalidFileExtension: "Type de fichier non autorisé.",
  Upload_InvalidFiles: "Fichiers non valides. Vérifie s'il te plaît les exigences pour le téléchargement de fichiers.",
  Upload_InvalidMaxFileSize: "Taille de fichier trop importante",
  Upload_InvalidMinFileSize: "Taille de fichier trop petite",
  Upload_SelectNoFilesTitle: "Appuyez sur cette touche pour sélectionner d'autres fichiers",
  Upload_SelectTitle: "Sélectionner des fichiers…",
  Upload_StatusFailed: "Les fichiers n'a/n'ont pas pu être téléchargés.",
  Upload_StatusUploaded: "Fichiers téléchargés avec succès.",
  Upload_StatusUploadFailed: "Les fichiers n'ont pas pu être téléchargés.",
  Upload_StatusUploading: "En cours de chargement …",
  Upload_StatusWarning: "Alerte",
  Upload_Total: "Total",
  Upload_UploadSelectedFiles: "Télécharger les fichiers sélectionnés",
  UploadFile: "Fichier",
  Upn: "Nom principal",
  User: "Utilisateur",
  User_AnonymizedDisplayName: "Utilisateur supprimé",
  User_Boards: "Organes",
  User_DisplayName: "Nom",
  User_Email: "Email",
  User_Email_Description: "Veuillez introduire votre adresse email.",
  User_Email_Title: "Email",
  User_FirstName: "Prénom",
  User_FirstName_Description: "Veuillez introduire le prénom.",
  User_FirstName_Title: "Prénom",
  User_Initials: "Initiales",
  User_Initials_Description: "Veuillez indiquer le raccourci de la personne",
  User_Initials_HelpText: `Si tu laisses le champ vide, le standard sera appliqué.<br/>
Première lettre du prénom, première lettre du nom de famille.`,
  User_Initials_Preview: "Preview",
  User_Initials_Title: "Initiales",
  User_Language: "Langue",
  User_LastName: "Nom de famille",
  User_LastName_Description: "Veuillez indiquer le nom de famille.",
  User_LastName_Title: "Nom de familie",
  User_LastSync: "Dernière synchronisation",
  User_OrganisationUnit: "Unité organisationnelle",
  User_PersonalSiteUrl: "URL du MySite SharePoint (OneDrive)",
  User_PersonnelNumber: "N° de personnel",
  User_Phone: "Téléphone",
  User_Status: "Statut",
  User_Sync_Error: "L'utilisateur n'a pas pu être synchronisé : {0}",
  User_Sync_NotSupported: "La synchronisation n'est pas prise en charge pour cet utilisateur",
  User_Sync_Success: "L'utilisateur a été synchronisé",
  User_Unknown: "Inconnu",
  User_Update_Error: "L'utilisateur n&apos;a pas pu être enregistré : {0}",
  User_Update_Success: "L'utilisateur a été enregistré",
  User_Upn: "Nom principal",
  User_UserRoles: "Rôles",
  UserMenu_MyDetails: "Mon profil",
  UserMenu_SignOut: "Se déconnecter",
  UserPicker: "Rechercher des utilisateurs",
  UserPicker_NoDataTemplate: "Pas trouvé de participants",
  UserPicker_Placeholder: "Saisir identifiant …",
  UserPreferences_Description: "Configure ici tes préférences pour l'affichage de la gestion des séances. Si tes autorisations ne comprennent pas, par exemple, l'affichage des éléments supprimés, le réglage correspondant n'a aucune influence.",
  UserRole_Administrator: "Administrateur",
  UserRole_Application: "Application",
  UserRole_BoardOwner: "Propriétaire organe",
  UserRole_Unknown: "Inconnu",
  UserRole_User: "Utilisateur",
  UserRoles: "Rôles",
  Users: "Utilisateurs",
  UserSettings: "Configurations",
  UserStatus_Deleted: "Supprimé",
  UserStatus_Enabled: "Actif",
  UserStatus_Unknown: "Inconnu",
  Validation_Board_CannotArchiveWithActiveMeetings: "Le comité ne peut pas être archivé car des séances actives existent encore.",
  Validation_Board_NameAlreadyUsed: "Un comité avec cette valeur existe déjà ({0}, {1})",
  Validation_Date_MustBeEarlierThan: "La valeur du champ '{0}' doit être antérieure à la valeur du champ '{1}'.",
  Validation_Date_YearAtLeast: "'{0}' (année) doit être supérieur ou égal à {1}.",
  Validation_Document_ContentBytesEmpty: "Le fichier transféré '{0}' a une longueur invalide de 0 octets.",
  Validation_Document_FileNameEmpty: "Le fichier transféré ne doit pas avoir un nom vide.",
  Validation_Document_IsProtected: "Le fichier transféré '{0}' a été détecté comme étant crypté, raison : {1}.",
  Validation_Field_ConcurrentDashes: "'{0}' ne peut pas contenir plusieurs traits d’union consécutifs.",
  Validation_Field_EndsWithDashes: "'{0}' ne doit pas se terminer par des tirets.",
  Validation_Field_InvalidCharacters: "'{0}' contient des caractères non valides ('{1}', position: {2}).",
  Validation_Field_LeadingOrTrailingWhitespace: "'{0}' ne doit pas contenir d’espace au début ou à la fin.",
  Validation_Field_MustBeGreaterThanZero: "'{0}' doit avoir une valeur supérieure à 0, est {1}.",
  Validation_Field_MustBeSameAs: "'{0}' ({1}) doit avoir la même valeur que '{2}' ({3}).",
  Validation_Field_MustNotBeEmpty: "'{0}' ne peut pas être vide.",
  Validation_Field_NotInValidNames: "'{0}' ne contient aucun des noms valides.",
  Validation_Field_StartsWithDashes: "'{0}' ne peut pas commencer par des tirets.",
  Validation_Participant_AlreadyExists: "Il y a déjà un participant '{0}' dans cette reunion.",
  ValidationFailures: "Erreurs de validation",
  View_AgendaItems_Details: "Détails",
  View_AgendaItems_Overview: "Vue globale",
  View_AgendaItems_Protocol: "Protocole",
  View_Documents_Grid: "Vue globale",
  View_OneDriveSync_Overview: "Synchr. OneDrive",
  View_Participants_Details: "Détails",
  View_Participants_Overview: "Vue globale",
  View_Tasks_Overview: "Vue globale",
  View_Views_Edit: "Modifier",
  Visitor: "Visiteurs",
  WorkingDocument: "Document de travail",
  WorkingDocument_FileExtension: "Extension de fichier",
  WorkingDocument_FileName: "Nom de fichier",
  WorkingDocument_FileSize: "Grandeur",
  WorkingDocument_StorageUrl: "Url de Blob",
  WorkingDocument_UniqueId: "Id unique",
  WorkingDocuments: "Documents de travail",
  WorkingDocuments_Add_Button: "Télécharger un document",
  WorkingDocuments_Description: "Contient les documents de travail de l'organe",
  WorkingDocuments_Tooltip: "Ouvrir le classeur correspondant dans les documents de travail.",
  Yes: "Oui",
};
